// 酒店业务逻辑加工 Mixin - 修正版
export const STOCK_TYPE_MAP = { 0: '正常', 1: '主推', 2: '全款', 3: '口头拿房', 4: '展会独家', 5: '全年独家' };

export const hotelLogic = {
  data() {
    return { STOCK_TYPE_MAP };
  },
  computed: {
    processedHotels() {
      if (!this.localHotelList || this.localHotelList.length === 0) return [];
      const currentExh = this.query.selectedExhibition;

      return this.localHotelList.map((hotel) => {
        const lat = hotel.Latitude || hotel.lat;
        const lng = hotel.Longitude || hotel.lng;
        
        // 1. 展馆距离计算
        let targetHall = null, distance = 0, targetHallName = '暂无展馆信息';
        if (hotel.Hall && hotel.Hall.length > 0) {
          if (currentExh) targetHall = hotel.Hall.find(h => h.HallId === currentExh.HallId);
          if (!targetHall) targetHall = hotel.Hall.reduce((prev, curr) => (prev.Distance < curr.Distance) ? prev : curr);
          if (targetHall) { distance = targetHall.Distance; targetHallName = targetHall.HallNameCn; }
        }

        let minPrice = 99999, hasBus = false, hasBreakfast = false, hasReception = false;
        let roomStockTypes = new Set(); 
        let dailyTotalMap = {}; // 按日期存储总库存

        if (hotel.Room && Array.isArray(hotel.Room)) {
          hotel.Room.forEach(r => {
            if(r.Rooms && Array.isArray(r.Rooms)) {
              r.Rooms.forEach(d => {
                // ★ 关键修复点：只统计入住期间的库存（不含离店日）
                if (this.isDateInQueryRange(d.CheckDate)) {
                  const dateStr = d.CheckDate.substring(0, 10);
                  if (d.Price < minPrice && d.Price > 0) minPrice = d.Price;
                  
                  // 累加该酒店当日所有房型库存
                  dailyTotalMap[dateStr] = (dailyTotalMap[dateStr] || 0) + d.AvailableRoom;

                  if (d.IsBus || (d.BusTypeStr && d.BusTypeStr.indexOf('班车') > -1)) hasBus = true;
                  if (d.IsBreakfast) hasBreakfast = true;
                  if (d.IsReception) hasReception = true;
                  if (d.StockType !== undefined) roomStockTypes.add(d.StockType);
                }
              })
            }
          });
        }

        // --- 逻辑 B 计算核心 (连住最小库存) ---
        let totalAvailable = 0;
        const dailyCounts = Object.values(dailyTotalMap);
        
        if (this.apiQuery.dateRange && this.apiQuery.dateRange.length === 2) {
          const start = new Date(this.apiQuery.dateRange[0]);
          const end = new Date(this.apiQuery.dateRange[1]);
          // ★ 关键修复点：diffDays 代表的是间夜数 (1号进2号出 = 1间夜)
          const diffDays = Math.floor((end - start) / (1000 * 60 * 60 * 24));
          
          if (diffDays <= 0) {
              totalAvailable = dailyCounts.length > 0 ? Math.max(...dailyCounts) : 0;
          } else {
              // 如果返回的库存天数 满足 连住所需要的间夜数
              if (dailyCounts.length >= diffDays) {
                totalAvailable = Math.min(...dailyCounts);
              } else {
                totalAvailable = 0; // 只要有一天没房，连住就不成立
              }
          }
        }

        return {
          ...hotel, lat, lng, distance, targetHallName, hasBus, hasBreakfast, hasReception,
          walletBalance: hotel.AvailableWallectFee || 0,
          minPrice: minPrice === 99999 ? 0 : minPrice,
          totalAvailable,
          stockTypes: Array.from(roomStockTypes),
          isMain: hotel.RecommendedHotelsType === 1 || roomStockTypes.has(1)
        };
      });
    },

    filteredHotels() {
      // 保持之前的排序和筛选逻辑不变
      return this.processedHotels.filter(h => {
        const q = this.localQuery;
        if (q.features.includes('hasWallet') && h.walletBalance <= 0) return false;
        if (q.features.includes('isBus') && !h.hasBus) return false;
        if (q.features.includes('mustBreakfast') && !h.hasBreakfast) return false;
        if (q.features.includes('mustReception') && !h.IsForeign) return false;


        if (q.distance !== 999 && h.distance > q.distance * 1000) return false;
        if (q.stars.length > 0 && !q.stars.includes(h.Star)) return false;
        if (q.stockTypes.length > 0 && !h.stockTypes.some(t => q.stockTypes.includes(t))) return false;

        return true;
      }).sort((a, b) => {
        //if (!!b.IsGuarantee !== !!a.IsGuarantee) return (b.IsGuarantee ? 1 : 0) - (a.IsGuarantee ? 1 : 0);
        const bHasW = b.walletBalance > 0, aHasW = a.walletBalance > 0;
        if (bHasW !== aHasW) return bHasW ? 1 : -1;
        if (bHasW && aHasW && b.walletBalance !== a.walletBalance) return b.walletBalance - a.walletBalance;
        if (b.isMain !== a.isMain) return (b.isMain ? 1 : 0) - (a.isMain ? 1 : 0);
        return a.distance - b.distance;
      });
    },

    activeFilterTags() {
      const tags = [], q = this.localQuery;

      if (q.features.includes('hasWallet')) tags.push({ key: 'hasWallet', label: '有定金', type: 'feature' });
      if (q.features.includes('isBus')) tags.push({ key: 'isBus', label: '有班车', type: 'feature' });
      if (q.features.includes('mustBreakfast')) tags.push({ key: 'mustBreakfast', label: '含早', type: 'feature' });
      if (q.features.includes('mustReception')) tags.push({ key: 'mustReception', label: '接待外宾', type: 'feature' });

      if (q.distance !== 999) tags.push({ key: 'distance', label: `${q.distance}km内` });
      q.stars.forEach(s => tags.push({ key: `star-${s}`, label: `${s}星级`, val: s, type: 'star' }));
      q.stockTypes.forEach(t => tags.push({ key: `stock-${t}`, label: STOCK_TYPE_MAP[t], val: t, type: 'stock' }));
      return tags;
    }
  },
  methods: {
    isDateInQueryRange(checkDateStr) {
      if (!this.apiQuery.dateRange || this.apiQuery.dateRange.length < 2) return true;
      const check = new Date(checkDateStr.substring(0, 10)).getTime();
      const start = new Date(this.apiQuery.dateRange[0]).getTime();
      const end = new Date(this.apiQuery.dateRange[1]).getTime();
      
      // ★ 核心逻辑：库存日期必须 >= 入住日，且 < 离店日
      return check >= start && check < end; 
    }
  }
};